import type { CreateSubmissionPayload, CreateTemplatePayload } from '@domain/schemas/payload.schema';
import type { CreateSubmissionResponse } from '@responses/submissions';
import type { CreateTemplateResponse } from '@responses/templates';
import axios from 'axios';

import { getRequestAuthPayload } from '../helpers/getRequestAuth';
import { queryClient } from '../utils/queryClient';

export const createTemplate =
  (isTemplate: boolean) =>
  async (
    data: CreateTemplatePayload | CreateSubmissionPayload,
  ): Promise<CreateTemplateResponse | CreateSubmissionResponse> => {
    const networkPayload = await getRequestAuthPayload({
      method: 'post',
      url: `${isTemplate ? 'templates' : 'submissions'}`,
      data,
    });

    const response = await axios(networkPayload);

    if (isTemplate) {
      await queryClient.invalidateQueries({ queryKey: ['templates'] });
    } else {
      await queryClient.invalidateQueries({ queryKey: ['submissions'] });
    }
    await queryClient.invalidateQueries({ queryKey: ['search'] });
    return response.data;
  };
